export default __webpack_public_path__ + "OpenSans-Light-ed41bedf131bc097372a961dbec109a1.ttf";